import React from "react";
import { Box, Typography, Chip } from "@mui/material";

import { Backdrop, IconButton } from "../v3";
import { ProjectCard } from ".";

export const ProjectHeader = ({ title = null, chipText = null, actionButtons = [], cards = [] }) => {
  return (
    <Box sx={{ marginX: "22px" }}>
      <Box
        sx={{
          position: "relative",
          padding: "22px",
          borderRadius: "16px",
          color: "#fff",
          backgroundColor: "#674BF5",
          overflow: "hidden",
        }}
      >
        {/* backdrops */}
        <Box sx={{ position: "absolute", inset: 0, zIndex: 0 }}>
          <Backdrop position={{ left: "20%", bottom: "65%" }} />
          <Backdrop position={{ left: "40%", top: "20%" }} />
          <Backdrop position={{ right: "20%", bottom: "65%" }} />
        </Box>

        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "#fff",
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {/* title */}
              <Box
                component="span"
                sx={{
                  display: "inline-block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "80%",
                  verticalAlign: "middle",
                }}
              >
                {title}
              </Box>

              {/* chip */}
              {chipText && (
                <Chip
                  component="span"
                  label={chipText}
                  sx={{
                    backgroundColor: "transparent",
                    color: "#fff",
                    fontWeight: 500,
                    fontSize: "0.85rem",
                    letterSpacing: "0.5px",
                    borderRadius: "20px",
                    border: "1px solid rgba(255, 255, 255, 0.8)",
                    display: "inline-flex",
                    verticalAlign: "middle",
                    ml: 1,
                    flexShrink: 0,
                    height: 22,
                  }}
                />
              )}
            </Typography>
          </Box>

          {/* buttons with icons */}
          {actionButtons.length > 0 && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {actionButtons.map((button, index) => (
                <IconButton
                  key={index}
                  icon={button?.icon}
                  buttonText={button?.buttonText}
                  tooltip={button?.tooltip}
                  onClick={button?.onClick}
                  styles={button?.styles}
                  hoverStyles={button?.hoverStyles}
                />
              ))}
            </Box>
          )}
        </Box>

        {/* bottom cards */}
        {cards.length > 0 && (
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              display: "flex",
              flexWrap: "wrap",
              gap: "22px",
              marginTop: "22px",
            }}
          >
            {cards.map((card, index) => (
              <ProjectCard key={index} title={card.title} value={card.value} color={card.color} icon={card.icon} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};
